<template>
  <div class="app-content">
    <transition name="el-fade-in-linear">
      <div v-show="promptShow" class="back">
        <div v-show="promptShow" class="copyLink">
          <h1>提示</h1>
          <p>{{ promptContent }}</p>
          <button v-if="promptValue == 'copy'" @click="copyLink">复 制</button>
          <button v-else @click="promptShow = false">确 定</button>
        </div>
      </div>
    </transition>

    <div class="center" :style="[baseStyles]">
      <div class="downloadButton" v-if="isShowOpenApp">
        <!-- <div class="downloadButton" @click="download">立即下载</div> -->
        <span class="openApp2Font">App 内打开</span>
        <div class="openAppStyle">
          <wx-open-launch-app @click="copyLinkClick" id="openApp2" style=" position: absolute;top: 0; left:0;width:100%;height: 100%;" appid="wx35f164d814467bdc" :extinfo="extinfoCon"  @launch="AppLaunch" @error="AppError" >
            <component is="script" type="text/wxtag-template">
              <div style=" position: absolute;top:0;left:0;width: 96%;height: 100%;border:none;background-color:transparent;"></div>
            </component>
          </wx-open-launch-app>
        </div>
      </div>
      <div class="downloadButton" @click="closeWeb" v-else>App 内打开</div>
    </div>
    <div class="zhezhao" v-if="dialog">
      <img src="../../assets/images/zhezhao.png" alt="">
    </div>
  </div>
</template>
<script>
import store from '@/store'
import wx from 'weixin-js-sdk'
import CryptoJS from "crypto-js";
import { getIsValid } from "@/api/score/score";
import { getQueryParams } from '@/utils/index'
import axios from 'axios'
export default{
  name:"download",
  data(){
    return{
      baseStyles:{},
      redirectBrowserConfig:"",
      extinfoCon:"ydddoctor://startup",
      promptShow: false,
      promptValue: '',
      promptContent: '',
      timer:null,
      dialog: false,
      isShowOpenApp: false,
      inviteSign:null,
      isValid: true
    }
  },
  created(){
    store.dispatch('settings/setTitle', '圣云执业医师考试')
    if (this.$route.query.inviteSign) {
      this.inviteSign =  this.$route.query.inviteSign.replace(/\%20/g,"%2B");
      this.extinfoCon = this.extinfoCon + "?shareCode=" + this.inviteSign;
      this.getValid();
    } else {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        // this.ejectPrompt('copy')
        // this.dialog = true
        this.isShowOpenApp = true;
        this.getApp();
      } else {
        // this.closeWeb()
      }
      this.isValid = false
    }
    console.log("????????", getQueryParams().redirectBrowserConfig)
    if( getQueryParams().redirectBrowserConfig ){
      this.baseStyles = {
        backgroundImage:`url(${ getQueryParams().redirectBrowserConfig.includes("http") ? getQueryParams().redirectBrowserConfig: this.imgUrl + getQueryParams().redirectBrowserConfig})`
      } 
    }

  },
  methods:{
    getValid(){
      getIsValid(this.inviteSign).then((res) => {
        this.isValid = true
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          // this.ejectPrompt('copy')
          // this.dialog = true
          this.isShowOpenApp = true;
          this.getApp();
        } else {
          // this.closeWeb()
        }
      }).catch(err => {
        this.isValid = false
        let ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          // this.ejectPrompt('copy')
          // this.dialog = true
          this.isShowOpenApp = true;
          this.getApp();
        } else {
          // this.closeWeb()
        }
      })
    },

    copyLinkClick(){
      if (this.isValid) {
        this.copyLink();
      }
    },

    butLister2(){
      console.log("***********",document.getElementById("openApp2"))
      let btn2 = document.getElementById("openApp2");
      // 打开这个要用1.6的微信sdk
      btn2.addEventListener('ready', (e)=> {
        // js中，我是在这里添加的extinfo内容，
        console.log("ready")
      })
      btn2.addEventListener('launch', (e)=> {
        if (this.isValid) {
          this.copyLink();
        }
        console.log("launch")
      })
      btn2.addEventListener('error', (e)=> {
        if (this.isValid) {
          this.copyLink();
        }
        if(e.detail){
          if(this.judgeClient() == "IOS"){
            window.location.href = "https://apps.apple.com/us/app/执业医师考试-执业医师/id6469769193";
            // this.dialog = true;
          }else{
            this.dialog = true;
          }
        }
        console.log("error")
      })

    },
    getApp(){
      axios.get('https://www.medmeta.com/api/wechat/wx/jsapi/wx73d5eb8e6d65981e/getJsapiTicket').then( res => {
        console.log("???????",res);
        if(res!=null){
          let that = this;
          let url = window.location.href;
          console.log(url)
          url = url.split('#')[0]

          let tick = res.data;
          let time = parseInt(new Date().getTime()/1000);
          let nums = this.suijione(true,true,false,16);

          let str = 'jsapi_ticket='+ tick + '&noncestr='+ nums  +'&timestamp='+ time + '&url='+ url;

          let signature = CryptoJS.SHA1(str).toString();
          let appid = "wx73d5eb8e6d65981e"
          console.log("测试数据",tick,time,nums,str,signature,appid)
          wx.config({
            debug: false,
            appId: appid,  // 此处APPID为公众号的APPID
            timestamp: time,
            nonceStr: nums,
            signature: signature,
            jsApiList: ['wx-open-launch-app','onMenuShareTimeline'], //此处必须填写一个，不为null就行
            openTagList: ['wx-open-launch-app']
          })
          wx.ready( () => {
            console.log('ready')
            wx.checkJsApi({
              jsApiList: ['wx-open-launch-app'], // 校验跳转APP的标签是否可用
              success: function (res) {
                console.log('可用')
                console.log('config111');
              },
              fail: (err) => {
                console.log(err, '不可用')
              }
            });
            that.butLister2();
            
          })
          wx.error(function(res){
            alert(res)
            console.log("error：",res)
          });

        }
      })
    },

    AppLaunch(e){
	  	if (this.isValid) {
        this.copyLink();
      }
	  },
	  AppError(e){
      if (this.isValid) {
        this.copyLink();
      }
	  	console.log("fail",e.detail)
	  },
    // 监听error 函数
	handleErrorFn (e) {
	  // 跳转失败
	  console.log(JSON.stringify(e), '跳转失败')
	  download() // 这里跳转App下载页面
	},
    // 监听launch 函数
    handleLaunchFn (e) {
      // 跳转成功
      console.log(JSON.stringify(e), '跳转成功')
    },
    getRandom(a,b){
      var max = a;
      var min = b;
      if(a<b){
        max = b;
        min = a;
      }
      return parseInt(Math.random()*(max-min))+min;
    },
    suijione(num,maxA,minlA,fqy){
      let arr=[]
      let arr1=[]
      let arr2=[]
      if(num){
        for(let m=0;m<=9;m++){
          arr.push(m)
        }
      }
      if(maxA){
        for(let m=65;m<=90;m++){
          arr1.push(m)
        }
      }
      if(minlA){
        for(let m=97;m<=122;m++){
          arr2.push(m)
        }
      }
      if(!fqy){
        console.log('生成位数必传')
      }
      let mergeArr = arr.concat(arr1);
      let mergeArr1 = mergeArr.concat(arr2);
      let _length=mergeArr1.length
      let text=''
      for(let m=0;m<fqy;m++){
        let text1=''
        let random= this.getRandom(0,_length)
        if((mergeArr1[random])<=9){
          text1=mergeArr1[random]
        }else if((mergeArr1[random])>9){
          text1=String.fromCharCode(mergeArr1[random])
        }
        text+=text1
      }
      return text
    },


    ejectPrompt(val,content){
      if (val == 'copy') {
        this.promptContent = '请复制链接地址，去外部浏览器中打开'
        this.promptShow = true
        this.promptValue = val
      } else {
        this.promptContent = content
        this.promptShow = true
        this.promptValue = val
      }
    },

    copyLink(){
      // 这边为链接地址
      // copyInput.value = window.location.href;
      // 复制的字符串

      if (this.$route.query.inviteSign) {
        this.inviteSign =  this.$route.query.inviteSign.replace(/\%20/g,"%2B");
        let copyInput = document.createElement("input");
        copyInput.value ="ydddoctor://shareCode=" + this.inviteSign;
        document.body.appendChild(copyInput); // 添加元素
        copyInput.select();
        document.execCommand("Copy"); // 执行浏览器复制命令
        document.body.removeChild(copyInput); // 移除刚创建的元素
        // this.$message.success("复制成功");
        // this.promptShow = false
      } else {
        // copyInput.value = "ydddoctor://shareCode=''";
      }
    },

    download() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.ejectPrompt('copy')
      } else {

        if (this.isValid) {
          this.copyLink();
        }
        if (this.judgeClient()=='Android') {
          //   window.location.href = 'https://file.medmeta.com/static/20231129/doctorapp.apk'
          // window.location.href = 'https://sj.qq.com/appdetail/com.yddmi.doctor'
          window.location.href = this.getPhoneType()
        } else if (this.judgeClient()=='IOS') {
          // window.location.href = `https://www.medmeta.com/ydddoctor?shareCode=${this.inviteSign}`;
          window.location.href = 'https://apps.apple.com/us/app/执业医师考试-执业医师/id6469769193'
          // window.location.href = "https://www.pgyer.com/U6AeL4"
          // this.ejectPrompt('prompt','暂未上架苹果商店，敬请期待')
        } else {

        }
      }
    },

    //判断手机型号
    getPhoneType(){
      let userAgent = navigator.userAgent;
      let brand = 'unknown';
      let href = 'https://sj.qq.com/appdetail/com.yddmi.doctor'//应用宝地址
      // let href = 'oppomarket://details?packagename=com.yddmi.doctor'//应用宝地址
      if(/iPhone|iPad/i.test(userAgent)){
        brand = 'Apple'
        href = 'https://apps.apple.com/us/app/id6469769193'
      }else if(/HUAWEI/i.test(userAgent)){
        brand = 'HUAWEI'
        href = 'appmarket://details?id=com.yddmi.doctor'
      }else if(/honor/i.test(userAgent)){
        brand = 'honor'
        href = 'appmarket://details?id=com.yddmi.doctor'
      }else if(/Xiaomi/i.test(userAgent)){
        brand = 'Xiaomi';
        href = 'mimarket://details?id=com.yddmi.doctor'
      }else if(/SamSung/i.test(userAgent)){
        brand = 'SamSung'
        href = 'samsungapps://ProductDetail/com.yddmi.doctor'
      }else if(/vivo/i.test(userAgent)){
        brand = 'vivo'
        href = 'vivomarket://details?id=com.yddmi.doctor'
      }else if(/HeyTapBrowser/i.test(userAgent)){
        brand = 'oppo'
        href = 'oppomarket://details?packagename=com.yddmi.doctor'
      }
      return href
    },

    closeWeb() {
      if (this.isValid) {
        this.copyLink();
      }
      if (this.judgeClient()=='Android') {
        this.closeWebAndroid()
        const timer = setTimeout(() => {
		    	this.download();
		    }, 1500);
		    document.addEventListener("visibilitychange", visibilitychange, false);
		    document.addEventListener("webkitvisibilitychange", visibilitychange, false);
		    window.addEventListener("pagehide",function() {
		    	clearTimeout(timer);
		    },
		    false
		    )

      } else if (this.judgeClient()=='IOS') {
        this.closeWebIOS()
        const timer = setTimeout(() => {
		    	this.download();
		    }, 3000);
		    document.addEventListener("visibilitychange", visibilitychange, false);
		    document.addEventListener("webkitvisibilitychange", visibilitychange, false);
		    window.addEventListener("pagehide",function() {
		    	clearTimeout(timer);
		    },
		    false
		    )
		    function visibilitychange() {
		    	const tag = document.hidden || document.webkitHidden;
		    	tag && clearTimeout(timer);
		    }
      } else {

      }
    },

    closeWebAndroid() {
      if (this.$route.query.inviteSign) {
        try {
          this.inviteSign =  this.$route.query.inviteSign.replace(/\%20/g,"%2B");
        window.location.href =
          "openapp://syyxcloud.com.doctor?shareCode=" +
          this.inviteSign;
        } catch (error) {
          alert(error)
        }
      } else {
        window.location.href = "openapp://syyxcloud.com.doctor";
      }
    },

    closeWebIOS() {
      if (this.$route.query.inviteSign) {
        this.inviteSign =  this.$route.query.inviteSign.replace(/\%20/g,"%2B");
        window.location.href =
          "ydd9528://app/shareToLogin?shareCode=" +
          this.inviteSign;
      } else {
        window.location.href = "ydd9528://";
      }
    },

    judgeClient() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);  //判断是否是 iOS终端
      if(isAndroid){
        return 'Android';
      }else if(isIOS){
        return 'IOS';
      } else{
        return 'PC';
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.app-content {
  width: 100%;
  height: 100%;

  .back {
    position:absolute;
    left:0;
    top:0;
    width:100%;
    height:100%;
    background: rgba(0,14,14,0.5);
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(1px);
    .copyLink {
      width: 7.7333rem;
      // height: 4.8rem;
      background-color: #fff;
      border-radius: .1067rem;
      h1 {
        font-size: .48rem;
        font-weight: 500;
        margin-top: .5333rem;
        color: #545454;
        padding: 0 .4rem 0 .4rem;
        text-align: center;
      }
      p {
        font-size: .4267rem;
        margin-top: .4rem;
        color: #b2b2b2;
        padding: 0 .4rem 0 .4rem;
        text-align: center;
      }
      button {
        width: 100%;
        height: 1.3333rem;
        margin-top: .6667rem;
        border: 0;
        border-top: 1px solid #efefef;
        border-radius: 0rem;
        background-color: #fff;
        font-size: .5333rem;
        font-weight: 600;
        color: #4ec39f;
        border-radius: 0 0 .1067rem .1067rem;
      }
    }
  }

  .center {
    width: 100%;
    height: 100vh;
    background: url('../../assets/images/downloadBack.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    .downloadButton {
      width: 6.8533rem;
      height: 1.28rem;
      // background-color: #db0909;
      background: url('../../assets/images/downloadButton.png') no-repeat;
      background-size: 100%;
      font-size: 20px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 1.2267rem;
      text-align: center;
      position: fixed;
      bottom: 1.5rem;
      .openAppStyle {
        width: 6.8533rem;
        height: 1.28rem;
        position: absolute;
        top: 0;
        left: 0;
        #openApp,#openApp2{
          width:100%;
          height:100%;
          div{
            width:100%;
            height:100%;
            button{
              width:100%;
              height:100%;
            }
          }
        }
        #openApp2{
          width: 6.8533rem;
          height: 1.28rem;
        }
      }
    }
  }
  .zhezhao {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
